import { useWindowSize } from './use-window-size';
/**
 * @internal Do not use it
 * @param breakpoints
 */
export const useCustomBreakpoints = (breakpoints, base) => {
  const windowSize = useWindowSize();
  const sortedBreakpoints = Object.keys(breakpoints).map(key => [key, breakpoints[key]]).sort((a, b) => a[1] - b[1]);
  const getCurrentBreakpoint = () => {
    let result = base || null;
    for (let index = 0; index < sortedBreakpoints.length; index += 1) {
      const [name, size] = sortedBreakpoints[index];
      if (windowSize.innerWidth <= size) {
        result = name;
      }
    }
    return result;
  };
  return getCurrentBreakpoint();
};